export { default } from './PublisherInvitationSuccess';
